var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.sale && _vm.sale.Contact && _vm.sale.ContactID
    ? _c(
        "w-breadcrumb",
        {
          attrs: {
            "no-container-margin": _vm.state.shouldUseMobileLayout,
            "no-container-padding": _vm.state.shouldUseMobileLayout,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contact-details" },
            [
              _vm.sale.Contact.Info != "" || _vm.displayExtraFields
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("contact-info"),
                          expression: "$ct('contact-info')",
                        },
                      ],
                      staticClass: "mrs info-circle",
                      class: {
                        expired: _vm.clientStats.Expired > 0,
                        open: _vm.clientStats.Open > 0,
                      },
                      attrs: { round: "", sm: "" },
                      on: {
                        click: function ($event) {
                          _vm.contactInfoModal = !_vm.contactInfoModal
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "info" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "span",
                {
                  staticClass: "sale-contact",
                  on: {
                    mouseenter: _vm.onContactEnter,
                    mouseleave: _vm.scheduleHideHoverCard,
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.sale.Contact.getDisplayName()) + " "),
                  _c("div", { staticClass: "smaller" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.moreText) +
                        " " +
                        _vm._s(
                          _vm.$ct(
                            _vm.sale.Contact.GroupID == 3
                              ? "prospect-id"
                              : "contact-id"
                          )
                        ) +
                        " " +
                        _vm._s(_vm.sale.Contact.ComputedFriendlyID) +
                        " "
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "contact-hover-card",
                      class: { visible: _vm.showHoverCard },
                      style: _vm.hoverCardStyle,
                      on: {
                        mouseenter: _vm.clearHideHoverCard,
                        mouseleave: _vm.scheduleHideHoverCard,
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "hover-name" }, [
                        _vm._v(_vm._s(_vm.sale.Contact.getDisplayName())),
                      ]),
                      _vm.hoverAddressLines.length
                        ? _c(
                            "div",
                            { staticClass: "hover-address" },
                            _vm._l(_vm.hoverAddressLines, function (line, i) {
                              return _c("div", { key: i }, [
                                _vm._v(_vm._s(line)),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "hover-row" },
                        [
                          _c("w-fa", {
                            staticClass: "hover-icon",
                            attrs: { icon: "hashtag" },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$ct(
                                  _vm.sale.Contact.GroupID == 3
                                    ? "prospect-id"
                                    : "contact-id"
                                )
                              ) +
                                " " +
                                _vm._s(_vm.sale.Contact.ComputedFriendlyID)
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.hoverEmail
                        ? _c(
                            "a",
                            {
                              staticClass: "hover-row link",
                              attrs: { href: "mailto:" + _vm.hoverEmail },
                            },
                            [
                              _c("w-fa", {
                                staticClass: "hover-icon",
                                attrs: { icon: "envelope" },
                              }),
                              _c("span", [_vm._v(_vm._s(_vm.hoverEmail))]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sale.Contact.MainAddress &&
                      _vm.sale.Contact.MainAddress.Phone
                        ? _c(
                            "a",
                            {
                              staticClass: "hover-row link",
                              attrs: { href: _vm.sale.Contact.getCleanPhone() },
                            },
                            [
                              _c("w-fa", {
                                staticClass: "hover-icon",
                                attrs: { icon: "phone" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.sale.Contact.MainAddress.Phone)
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sale.Contact.MainAddress &&
                      _vm.sale.Contact.MainAddress.Mobile
                        ? _c(
                            "a",
                            {
                              staticClass: "hover-row link",
                              attrs: {
                                href: _vm.sale.Contact.getCleanMobile(),
                              },
                            },
                            [
                              _c("w-fa", {
                                staticClass: "hover-icon",
                                attrs: { icon: "mobile-alt" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.sale.Contact.MainAddress.Mobile)
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sale.Contact.Vat
                        ? _c(
                            "div",
                            { staticClass: "hover-row" },
                            [
                              _c("w-fa", {
                                staticClass: "hover-icon",
                                attrs: { icon: "building" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$ct("vat-number")) +
                                    " " +
                                    _vm._s(_vm.sale.Contact.Vat)
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm.isMobile
                ? _c("w-button", {
                    staticClass: "btt-edit",
                    attrs: { icon: "pencil-alt" },
                    on: {
                      click: function ($event) {
                        return _vm.clearContact()
                      },
                    },
                  })
                : _vm._e(),
              _vm.sale.Contact.Blocked
                ? _c(
                    "span",
                    { staticClass: "warning" },
                    [
                      _c("w-fa", { attrs: { icon: "exclamation-triangle" } }),
                      _vm._v(" " + _vm._s(_vm.$ct("warning-contact-blocked"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("w-spacer"),
          _vm.connectedUsers && _vm.connectedUsers.length > 0
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("connected-users"),
                      expression: "$ct('connected-users')",
                    },
                  ],
                  staticClass: "connected",
                },
                [
                  _c("div", { staticClass: "indicator" }),
                  _c("div", { staticClass: "user-name" }, [
                    _vm._v(_vm._s(_vm.connectedUsersList)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.showLoyaltyBalance
            ? _c(
                "w-chip",
                {
                  staticClass: "loyalty-pill",
                  attrs: { clickable: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openLoyaltyRedeemModal()
                    },
                  },
                },
                [
                  _c("w-fa", { staticClass: "mrs", attrs: { icon: "star" } }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$ct("loyalty.points-pill", {
                          points: _vm.state.loyalty.balance || 0,
                        })
                      ) +
                      " "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.$wf.isMdUp
            ? _c(
                "w-button-bar",
                { staticClass: "ml" },
                [
                  _vm._l(_vm.quickButtonItems, function (item) {
                    return _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: item.text,
                            expression: "item.text",
                          },
                        ],
                        key: item.key,
                        attrs: { disabled: item.disabled },
                        on: {
                          click: function ($event) {
                            return item.value()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: item.icon } })],
                      1
                    )
                  }),
                  _c(
                    "w-dropdown",
                    {
                      attrs: { items: _vm.buttonBarItems, right: "" },
                      on: {
                        click: function ($event) {
                          return $event()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "bars" } })],
                    1
                  ),
                ],
                2
              )
            : _c(
                "w-dropdown",
                {
                  staticClass: "ml",
                  attrs: { items: _vm.buttonBarItems, right: "" },
                  on: {
                    click: function ($event) {
                      return _vm.trigger($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "bars" } })],
                1
              ),
          !_vm.state.shouldUseMobileLayout
            ? _c(
                "w-button",
                {
                  staticClass: "ml",
                  attrs: { right: "" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$ct("finish", { type: _vm.saleTypeName })) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.importSalesModalState.shown
            ? _c(
                "w-modal",
                { attrs: { value: "" } },
                [
                  _c(
                    "w-card",
                    { style: { maxWidth: "95%", top: "20px" } },
                    [
                      _c(
                        "w-card-title",
                        { staticClass: "blue" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("document-import")) + " "
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-link",
                            {
                              attrs: { white: "" },
                              on: {
                                click: function ($event) {
                                  _vm.importSalesModalState.shown = false
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-tabs", {
                        style: { margin: "4px 0 0 18px" },
                        attrs: { tabs: _vm.importSaleTabs },
                        model: {
                          value: _vm.activeImportSaleTab,
                          callback: function ($$v) {
                            _vm.activeImportSaleTab = $$v
                          },
                          expression: "activeImportSaleTab",
                        },
                      }),
                      _c(
                        "div",
                        { style: { height: "calc(100vh - 180px)" } },
                        [
                          _vm.sale.ContactID
                            ? _c("app-import-sale", {
                                attrs: {
                                  "contact-id": _vm.sale.ContactID,
                                  "contact-group-id":
                                    _vm.importSalesModalState.contactGroupId,
                                  "disable-contact-filter":
                                    _vm.importSalesModalState
                                      .disableContentFilter,
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.importSalesModalState.shown = false
                                  },
                                  select: function ($event) {
                                    return _vm.importSales($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.importSalesModalState.saleRowsShown
            ? _c(
                "w-modal",
                { attrs: { value: "" } },
                [
                  _c(
                    "w-card",
                    { style: { maxWidth: "95%", top: "20px" } },
                    [
                      _c(
                        "w-card-title",
                        { staticClass: "blue" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("sale-row-import")) + " "
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-link",
                            {
                              attrs: { white: "" },
                              on: {
                                click: function ($event) {
                                  _vm.importSalesModalState.saleRowsShown = false
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { style: { height: "calc(100vh - 180px)" } },
                        [
                          _vm.sale.ContactID
                            ? _c("app-import-sale-row", {
                                attrs: {
                                  "contact-id": _vm.sale.ContactID,
                                  "contact-group-id": 1,
                                  "disable-contact-filter":
                                    _vm.importSalesModalState
                                      .disableContentFilter,
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.importSalesModalState.saleRowsShown = false
                                  },
                                  select: function ($event) {
                                    return _vm.importSaleRows($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.state.publicLinkModal.shown,
                callback: function ($$v) {
                  _vm.$set(_vm.state.publicLinkModal, "shown", $$v)
                },
                expression: "state.publicLinkModal.shown",
              },
            },
            [
              _c("app-public-link", {
                attrs: { link: _vm.state.publicLinkModal.link },
                on: {
                  cancel: function ($event) {
                    _vm.state.publicLinkModal.shown = false
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.contactInfoModal,
                callback: function ($$v) {
                  _vm.contactInfoModal = $$v
                },
                expression: "contactInfoModal",
              },
            },
            [
              _vm.contactInfoModal
                ? _c("app-contact-info-modal", {
                    attrs: {
                      contact: _vm.sale.Contact,
                      "client-stats": _vm.clientStats,
                      "default-tab": _vm.state.contactInfoModal - 1,
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.contactInfoModal = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.state.applyDiscountModal,
                callback: function ($$v) {
                  _vm.$set(_vm.state, "applyDiscountModal", $$v)
                },
                expression: "state.applyDiscountModal",
              },
            },
            [
              _c("app-apply-discount", {
                on: {
                  cancel: function ($event) {
                    _vm.state.applyDiscountModal = false
                  },
                  update: function ($event) {
                    return _vm.applySalesDiscount($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              attrs: { "escape-close": "" },
              model: {
                value: _vm.state.editExtraFieldsModal,
                callback: function ($$v) {
                  _vm.$set(_vm.state, "editExtraFieldsModal", $$v)
                },
                expression: "state.editExtraFieldsModal",
              },
            },
            [
              _c(
                "w-card",
                { attrs: { "max-width": 650 } },
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("extra-fields")))]),
                  _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-card-content" } },
                    [
                      _c("app-extra-fields-edit", {
                        attrs: {
                          value: _vm.sale.ExtraFields,
                          "name-settings": _vm.extraFieldsNameSettings,
                          "sale-type-id": _vm.sale.TypeID,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.state.editExtraFieldsModal = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.Ok")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }